var fails = require('../internals/fails');

module.exports = !fails(function () {
  return Object.isExtensible(Object.preventExtensions({}));
});



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/internals/freezing.js
// module id = 99
// module chunks = 20 21 22 23 24 25 26 27 28 29 30 31 32 33